




































import Vue from "vue"
import EditProduct from "@/pages/administration/products-editor/EditProduct.vue"
import {plainToClass} from "class-transformer"
import {DpdProductFull} from "@/model/new-parcel-model/dpd-product/dpd-product-full"
import {DpdProductVariant} from "@/model/new-parcel-model/dpd-product/dpd-product-variant.ts"

interface ProductsData {
  products: DpdProductFull[]
  entity: any
  defaultProps: any
  $refs: any
  productEntity: any
  showEdit: boolean
  product: any
}

export interface ProductsMethods extends Vue {
  save(): void
}

export default Vue.extend({
  components: {
    EditProduct
  },
  data(): ProductsData {
    return {
      showEdit: false,
      productEntity: {},
      entity: {},
      defaultProps: {
        children: "children",
        label: "label"
      },
      $refs: {
        tree: {} as any
      },
      products: [],
      product: {} as any
    }
  },
  methods: {
    async getData() {
      const vm = this
      await this.$http
        .get("/product/all_products")
        .then(response => {
          vm.products = response.data.map((product) => {
            return {name: product.title, type: product.type, dpdProductVariants: [{}]}
          })
        })


      vm.products.forEach(async (element) => {
        const res = await this.$http.get(`/product/product_variants/${element.type}`)
        element.dpdProductVariants.splice(0, 1, ...res.data)
      })
    },
    save(dpdProductVariant: DpdProductVariant) {
      const vm = this
      this.showEdit = false
      Object.assign(this.entity, dpdProductVariant)
      this.showEdit = false
      this.product.product_json = JSON.stringify(this.products)
      this.$http
        .put("/product/product_variant", dpdProductVariant)
        .then(() => vm.getData())
      this.productEntity = {}
    },
    back() {
      this.showEdit = false
    },
    edit(node: DpdProductVariant) {
      this.entity = node.data.newData
      this.showEdit = true
    },
    remove(node: any, data: any) {
      this.$confirm(String(this.$t("edit_products.delete_warning")), String(this.$t("general.warning")), {
        confirmButtonText: String(this.$t("general.confirm")),
        cancelButtonText: String(this.$t("general.cancel")),
        type: "warning"
      })
        .then(() => {
          const parent = node.parent
          const children = parent.data.children || parent.data
          const index = children.findIndex((d: any) => d.id === data.id)
          children.splice(index, 1)
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("products_editor.delete_cancelled").toString()
          })
        })
    }
  },
  computed: {
    treeData(): any {
      return this.products.map(product => {
        return {
          label: product.name,
          children: product.dpdProductVariants.map(variant => {
            return {
              label: variant.description,
              newData: variant
            }
          })
        }
      })
    }
  },
  created() {
    this.getData()
  }
})
